import { render, staticRenderFns } from "./GoogleConsent.vue?vue&type=template&id=0c464ada&scoped=true"
import script from "./GoogleConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleConsent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GoogleConsent.vue?vue&type=style&index=0&id=0c464ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c464ada",
  null
  
)

export default component.exports